import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getPermissionsAPI } from "../../api/apiv2";

// Async thunk to fetch user permissions
export const fetchPermissions = createAsyncThunk(
  "permissions/getPermissions",
  async () => {
    return await getPermissionsAPI();
  }
);

const permissionsSlice = createSlice({
  name: "permissions",
  initialState: {
    value: [],
  },
  reducers: {
    setPermissions: (state, action) => {
      state.value = action.payload;
    },
    clearPermissions: (state) => {
      state.value = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPermissions.fulfilled, (state, action) => {
      state.value = action.payload;
    });
  },
});

export const { setPermissions, clearPermissions } =
  permissionsSlice.actions;
export default permissionsSlice.reducer;
